export enum AuthorityEnum {
  ADMIN = 'ADMIN',
  PURCHASE = 'PURCHASE',
  MARKETING = 'MARKETING',
  DEVELOPER = 'DEVELOPER'
}
